import { AuthorizationPanel } from '__pages/Marketplace/Details/panels/Authorization';

type OAuthStepProps = {
  oAuthServices: any[];
  businessPluginApp: Record<string, any>;
  oAuthEvents: Array<any>;
  refetch: () => Promise<any>;
};

export const OAuthStep = (props: OAuthStepProps) => {
  return (
    <div>
      <AuthorizationPanel
        oAuthEvents={props.oAuthEvents}
        oAuthServices={props.oAuthServices}
        businessPluginApp={props.businessPluginApp}
        refetch={props.refetch}
        inline
      />
    </div>
  );
};
